
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 8.467 8.467"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.233.265A3.973 3.973 0 00.265 4.233a3.973 3.973 0 003.968 3.97 3.973 3.973 0 003.97-3.97A3.973 3.973 0 004.232.265zm0 .529a3.437 3.437 0 013.442 3.44 3.44 3.44 0 01-3.442 3.441 3.437 3.437 0 01-3.44-3.442 3.436 3.436 0 013.44-3.44zM4.23 2.118a.265.265 0 00-.26.268v.223c-.427.08-.793.355-.793.832 0 .33.15.598.35.754s.426.224.624.29c.199.067.37.13.467.206.098.075.144.14.144.338 0 .44-1.056.44-1.056 0a.265.265 0 10-.529 0c0 .476.366.752.793.832v.222a.265.265 0 10.529 0V5.86c.427-.08.793-.356.793-.832a.946.946 0 00-.35-.754c-.2-.156-.426-.226-.624-.292-.199-.066-.37-.129-.468-.204-.097-.076-.144-.14-.144-.338 0-.441 1.056-.441 1.056 0a.265.265 0 10.53 0c0-.476-.366-.751-.793-.832v-.223a.265.265 0 00-.27-.268z","fill":"#fff","data-original":"#000000"}})])
          )
        }
      }
    